import Vue from 'vue'
import Router from 'vue-router'
import login from '@/view/login'
import main from '@/view/main'
import homePage from '@/view/homePage/homePage'
import rest from '@/view/rest/rest'
import set from '@/view/set/set'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      name: 'main',
      path: '/main',
      component: main,
      redirect: "/main/homePage",
      children: [{
          name: 'homePage',
          path: 'homePage',
          component: homePage
        },{
          name: 'rest',
          path: 'rest',
          component: rest
        },{
          name: 'set',
          path: 'set',
          component: set
        }

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js